import type {
  HttpTransport,
  TransportRequestConfig,
} from '@mangovoice/api-client'

/**
 * Hotels resource - delegates to the @mangovoice/hotels-ui library
 * for actual endpoint definitions. This provides a pass-through transport adapter.
 *
 * The hotels-ui library defines its own endpoint URLs internally.
 */
export function createHotelsResource(transport: HttpTransport) {
  return {
    get: <T>(url: string, params?: Record<string, unknown>) =>
      transport.get<T>(url, params),

    post: <T>(url: string, data?: unknown) => transport.post<T>(url, data),

    patch: <T>(url: string, data?: unknown) => transport.patch<T>(url, data),

    put: <T>(url: string, data?: unknown) => transport.put<T>(url, data),

    delete: <T>(
      url: string,
      params?: Record<string, unknown>,
      config?: TransportRequestConfig,
    ) => transport.delete<T>(url, params, config),
  }
}
